import { useCallback, useState } from "react";

export function useAddSceneWizardBridge({ onSuccess } = {}) {
  const [addSceneWizard, setAddSceneWizard] = useState({
    open: false,
    scene: null,
  });

  const openAddSceneWizard = useCallback((scene) => {
    setAddSceneWizard({ open: true, scene });
  }, []);

  const closeAddSceneWizard = useCallback(() => {
    setAddSceneWizard({ open: false, scene: null });
  }, []);

  const handleAddSceneSuccess = useCallback(
    (therapy) => {
      onSuccess?.(therapy);
      closeAddSceneWizard();
    },
    [onSuccess, closeAddSceneWizard],
  );

  return {
    addSceneWizard,
    openAddSceneWizard,
    closeAddSceneWizard,
    handleAddSceneSuccess,
  };
}
